import React from 'react';
import Layout from '../../components/Layout/Layout';
import Support from './Support';

// Standalone Support page for the sidebar's Manage section
// (reuses the same ticket system as the Settings → Support tab)
const SupportPage = () => (
  <Layout>
    <Support />
  </Layout>
);

export default SupportPage;